import './tv.css'
import React, { useState, useEffect, useMemo } from "react";
import TehranInventory from '../TehranInventoryDashboard/TehranInventory';
import FactoriesInventory from '../FactoryInventory/FactoryInventory';
import IsfahanInventory from '../IsfahanInventory/IsfahanInventory';
import MiscellaneousInventory from '../MiscellaneousInventory/Miscellaneous';

const TVInventory = () => {
    return(
        <div>
        <TehranInventory></TehranInventory>
        <FactoriesInventory></FactoriesInventory>
        <IsfahanInventory></IsfahanInventory>
        <MiscellaneousInventory></MiscellaneousInventory>
        </div>
    )
}

export default TVInventory;
